import React from 'react';
import {useSelector} from "react-redux";
import TileCountCVEsForCustomerInView
    from "../../../../../components/customBreachBits/metrics/TileCountCVEsForCustomerInView";
import TileCountVectorsCampaignsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsCampaignsViableForCustomer";

import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import CIRTContinuousControlWidget
    from "../../../../../components/customBreachBits/controllers/CIRTControlButton/CIRTContinuousControlWidget";

import TileCountActiveBreaches from "../../../../../components/customBreachBits/metrics/TileCountActiveBreaches";
import BreachesTable from "../../../../../components/customBreachBits/vectors/breaches/BreachesTable";
import TileCountLifetimeBreaches from "../../../../../components/customBreachBits/metrics/TileCountLifetimeBreaches";
import Widget from "../../../../../components/prefabricated/Widget";
import TileCountVectorsNotViable from "../../../../../components/customBreachBits/metrics/TilePercentVectorQuality";
import TileCountActiveTargets from "../../../../../components/customBreachBits/metrics/TileCountActiveTargets";
import CIRTLogo from "../../../../../assets/images/logo-cirt-condensed-dark.svg"
import ExternalThreatBanner from "../../../../../assets/images/External-Threat.svg";
import {HashLink as Link} from "react-router-hash-link";
import TileCountVectorsViableForCustomer
    from "../../../../../components/customBreachBits/metrics/TileCountVectorsPotentiallyBreaching";
import TileCountHighRiskServices from "../../../../../components/customBreachBits/metrics/TileCountHighRiskServices";

const BreachBoardOverviewTab = ({children, onChangeActiveTab}, props) => {

    const {customerInView} = useSelector(({customer}) => customer);
    // const {boardActiveTab} = useSelector(({misc}) => misc);
    // const dispatch = useDispatch();
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    return (
        <div className={`bb-breachboard-overview`}>
            <div className="row">
                <div className={"col-2 align-self-center"}>
                    <div className={"mx-0 px-0"}>
                        <Tooltip title={"Continuous Intelligent Red Team"}>
                            <div style={{backgroundImage: `url(${CIRTLogo})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: "85px"}} />

                        </Tooltip>
                    </div>


                </div>
                <div className={"col-6 align-self-center"}>
                    <div className={"mx-0 px-0"}>
                        <div style={{backgroundImage: `url(${ExternalThreatBanner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                    </div>
                </div>
                <div className={"col-4 align-self-center"}>
                    {/*<CIRTContinuousControlWidget customerId={customerInView}/>*/}
                    <h3>Perception is reality <Tooltip title={"The External Threat module displays what hackers see about your company from the public Internet. The External Threat is the most likely breach approach."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                    <p>Set it and forget it.  Understand the External Threat with the Monitor module to continuously observe and the Perimeter and Social modules to test your systems from the public Internet, just like real attackers.</p>

                </div>


            </div>
            <hr/>
            <div className={"tourStep2-1"}>
                <div className={"row mb-2"}>
                    <div className={"col-8"}>
                        <h3>Key Risk Indicators <Tooltip title={"These Key Risk Indicators (KRIs) represent the most critical indications of your cybersecurity risk."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                        <p>KRIs represent the most critical indications of your cybersecurity risk from the hacker's perspective.  Viable, undefended Vectors increase risk.  Targets and Controls provide important context.  The color of each KRI indicates its contribution to your overall cybersecurity risk.</p>
                    </div>
                     <div className={"col-4 tourStep2"}>
                        <CIRTContinuousControlWidget customerId={customerInView}/>
                    </div>
                </div>

                <div className="row">
                    {/*<div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mx-0 px-1 py-0 "  style={{cursor: "pointer"}} onClick={(event, newValue) => onChangeActiveTab(1)}>*/}
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-0 px-1 py-0 "  >

                            <Widget styleName={" mx-0 px-1 py-1 pb-0 mb-0 tourStepAttackSurfaceOverview"}>
                                <div className="row">
                                    <div className="col-4">
                                        <Link smooth to={{pathname: "/board/CIRT/external/AttackSurface", hash:"SystemTargetsTable"}}>
                                            <TileCountActiveTargets/>
                                        </Link>
                                    </div>
                                    <div className="col-4">
                                        <Link smooth to={{pathname: "/board/CIRT/external/AttackSurface", hash:"VulnerableTargetsTable"}}>
                                            <TileCountCVEsForCustomerInView/>
                                        </Link>
                                    </div>
                                    <div className="col-4">
                                        <Link smooth to={{pathname: "/board/CIRT/external/AttackSurface", hash:"SystemTargetsTable"}}>
                                            <TileCountHighRiskServices/>
                                        </Link>
                                    </div>
                                </div>
                                <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Attack Surface</h2>
                                <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>What can be seen</p>
                            </Widget>

                    </div>

                    {/*<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 mx-0 px-1 py-0 " style={{cursor: "pointer"}} onClick={(event, newValue) => onChangeActiveTab(2)}>*/}
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mx-0 px-1 py-0 ">
                        <Widget styleName={"mx-0 px-1 py-1 mb-0 tourStepVectorsOverview"}>
                            <div className="row">

                                <div className="col-4">
                                    <Link smooth to={{pathname: "/board/CIRT/external/Vectors"}}>
                                        {/*<TileCountVectorsCampaignsViableForCustomer/>*/}
                                        <TileCountVectorsViableForCustomer/>
                                    </Link>
                                </div>
                                {/*<Divider orientation="vertical" flexItem style={{marginRight: -1, marginLeft: -1}}/>*/}
                                <div className="col-4">
                                    <Link smooth to={{pathname: "/board/CIRT/external/Vectors"}}>
                                        <TileCountVectorsNotViable/>
                                    </Link>
                                </div>
                                <div className="col-4">
                                    <Link smooth to={{pathname: "/board/CIRT/external/Vectors", hash:"PerimeterVectorsSection"}}>
                                        {/*<TileRecentlyDefendedLast30Days/>*/}
                                        <TileCountVectorsCampaignsViableForCustomer/>
                                    </Link>
                                </div>
                            </div>
                            <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Vectors</h2>
                            <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>What can be attacked</p>
                        </Widget>
                    </div>

                    {/*<div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 mx-0 px-1 py-0" style={{cursor: "pointer"}} onClick={(event, newValue) => onChangeActiveTab(3)}>*/}
                    {/*    <Widget styleName={"bg-lightest-gray mx-0 px-1 py-1 mb-0 tourStepControlsOverview"}>*/}
                    {/*        <div className="row">*/}
                    {/*            <div className="col-12">*/}
                    {/*                <TileComingSoon/>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <h2 className={"bb-row-section-title bb-font-fridge-bold"}>Controls</h2>*/}
                    {/*        <p className={"text-center bb-font-fridge bb-font-fridge-medium-size"}>Attack obstructions</p>*/}
                    {/*    </Widget>*/}

                    {/*</div>*/}

                </div>
            </div>
            <div className="row mt-4 tourStepBreachesTable">
                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                    <TileCountActiveBreaches/>
                </div>
                <div className="col-xl-8 col-lg-10 col-md-10 col-sm-12 col-12 tourStepVulnerableSystemTargetsTable">
                    <BreachesTable customerId={customerInView} current past/>
                </div>
                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                    <TileCountLifetimeBreaches/>
                </div>

            </div>
            {/*<div className="row">*/}
            {/*    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">*/}
            {/*        <TileCountLifetimeBreaches/>*/}
            {/*    </div>*/}
            {/*    <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 tourStepVulnerableSystemTargetsTable">*/}
            {/*        <BreachesTable customerId={customerInView} past/>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<hr/>*/}
            {/*<div className={"tourStep2-2"}>*/}
            {/*    <h3>Metrics and CIRT Activity <Tooltip title={"These metrics describe facts discovered about your organization and about CIRT activities."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>*/}
            {/*    <p>These metrics help further describe your organization and CIRT activities, but they are not principle contributors to your risk score.</p>*/}
            {/*    <div className="row">*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountIdentitiesForCustomerInView/>*/}
            {/*        </div>*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountTargetsForCustomerInView/>*/}
            {/*        </div>*/}
            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountInScopeTargetsForCustomerInView/>*/}
            {/*        </div>*/}

            {/*        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">*/}
            {/*            <TileCountVectorsForCustomer/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="row">*/}
            {/*    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">*/}
            {/*        <TabbedClientInfoCard/>*/}
            {/*    </div>*/}

            {/*</div>*/}



        </div>
    )
};

BreachBoardOverviewTab.propTypes = {
};

export default BreachBoardOverviewTab;

